import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Vehicle } from '../state-man/models/vehicle.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
 
  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: Vehicle[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('vehicle/active/', version)
      return ret && { version: ret.version, rows: ret.rows && Vehicle.buildMany(ret.rows) }
    } 
    catch (error) {    
      LoggerService.log(error + 'vehicle/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
